import { createActions } from "redux-actions";

export default createActions({
  INTERCOM_DATA: {
    REQUEST: (req: any) => ({ ...req }),
    SUCCESS: (res: any) => ({ ...res }),
    FAILURE: [(error: Error) => ({ error }), (error: Error) => ({ type: typeof error })],
  },
}) as any;
